"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAccountMenu = exports.StyledDropDown = exports.StyledCompany = exports.StyledItemsContainer = exports.StyledProductList = exports.StyledUserEmail = exports.StyledSideItem = exports.StyledName = exports.StyledSideNav = exports.StyledNavIcon = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _knotchincWebReactComponents = require("@bit/knotchinc.web-react-components.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  text-align: right;\n\n  & > ", " {\n    margin-bottom: 18px;\n\n    ", " {\n      position: absolute;\n      bottom: -18px;\n    }\n\n    .accountName {\n      vertical-align: top;\n    }\n  }\n\n  &:hover {\n    ", " {\n      transform: translateY(0);\n      visibility: visible;\n      opacity: 1;\n    }\n\n    .account {\n      opacity: 1;\n    }\n\n    ", " {\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  margin: auto;\n  width: 80%;\n  border-radius: 3px;\n  color: white;\n  overflow: hidden;\n  opacity: 0;\n  visibility: hidden;\n  height: auto;\n  position: absolute;\n  bottom: 200%;\n  left: 10%;\n  padding: 15px 0;\n  transition: all .3s ease;\n  transform: translateY(-5px);\n\n  .accountLabel {\n    font-size: 8px;\n    color: #5C6677;\n\n    &:hover {\n      cursor: default;\n\n      &:before {\n        background: none;\n      }\n    }\n  }\n\n  ", " {\n    margin-bottom: 10px;\n    padding-left: 18px;\n    width: auto;\n\n    &.accountLabel {\n      margin-bottom: 12px;\n    }\n\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  font-weight: 500;\n  color: white;\n  font-size: 13px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  transform: translateY(-50%);\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 60px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-left: 40px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: block;\n  height: 19px;\n  margin-bottom: 34px;\n  line-height: 22px;\n  font-size: 13px;\n  letter-spacing: 1px;\n  cursor: pointer;\n  padding-left: 19px;\n  padding-right: 21px;\n  position: relative;\n  width: 220px;\n  text-decoration: none;\n  transition: all .3s ease;\n\n  ", " {\n    opacity: .3;\n  }\n\n  &:hover {\n    color: white;\n    text-decoration: none;\n\n    ", " {\n      opacity: .7;\n    }\n  }\n\n  &.selected {\n    color: white;\n\n    ", " {\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  text-align: right;\n  line-height: initial;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-left: 35px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  position: fixed;\n  width: 54px;\n  overflow: hidden;\n  transition: all .6s ease;\n  z-index: 10;\n  background: ", ";\n\n  &:hover {\n    width: 220px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  float: left;\n  position: relative;\n  top: 2px;\n  height: 12px;\n  width: 12px;\n  background-repeat: no-repeat;\n  background-size: 12px 12px;\n  background-position: center center;\n  background-image: url(", ");\n  transition: all .3s ease;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledNavIcon = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var url = _ref.url;
  return url;
});

exports.StyledNavIcon = StyledNavIcon;

var StyledSideNav = _styledComponents["default"].div(_templateObject2(), (0, _knotchincWebReactComponents.absFull)(0, 'auto', 0, 0), function (props) {
  return props.theme.colors.palette[4];
});

exports.StyledSideNav = StyledSideNav;

var StyledName = _styledComponents["default"].div(_templateObject3());

exports.StyledName = StyledName;

var StyledSideItem = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.theme.colors.palette[6];
}, StyledNavIcon, StyledNavIcon, StyledNavIcon);

exports.StyledSideItem = StyledSideItem;

var StyledUserEmail = _styledComponents["default"].div(_templateObject5());

exports.StyledUserEmail = StyledUserEmail;

var StyledProductList = _styledComponents["default"].div(_templateObject6());

exports.StyledProductList = StyledProductList;

var StyledItemsContainer = _styledComponents["default"].div(_templateObject7());

exports.StyledItemsContainer = StyledItemsContainer;

var StyledCompany = _styledComponents["default"].div(_templateObject8(), (0, _knotchincWebReactComponents.absFull)('26px', 0, 'auto', 0));

exports.StyledCompany = StyledCompany;

var StyledDropDown = _styledComponents["default"].div(_templateObject9(), function (props) {
  return props.theme.colors.palette[1];
}, StyledSideItem);

exports.StyledDropDown = StyledDropDown;

var StyledAccountMenu = _styledComponents["default"].div(_templateObject10(), (0, _knotchincWebReactComponents.absFull)('auto', 0, '24px', 0), StyledSideItem, StyledNavIcon, StyledDropDown, StyledSideItem);

exports.StyledAccountMenu = StyledAccountMenu;

//# sourceMappingURL=styled.js.map